import { render, staticRenderFns } from "./BrigadeMapBrigadeInformationEmployee.vue?vue&type=template&id=739b916c&"
import script from "./BrigadeMapBrigadeInformationEmployee.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapBrigadeInformationEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QItem,QItemSection,QImg,QSpinnerGears,QItemLabel,QInput,QIcon,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QCard,QItem,QItemSection,QImg,QSpinnerGears,QItemLabel,QInput,QIcon,QBtn,QTooltip}, component.options.components || {})
